import React from "react";
import {
  TableWrapper,
  StyledTable,
  CellInner,
  IconImg,
  RecommendedBadge,
} from "./ComparisonTableElements";

const ComparisonTable = ({
  leftTitle,
  leftIcon,
  rightTitle,
  rightIcon,
  leftRows,
  rightRows,
  showRecommendedBadge,
  recommendedBadgeText,
  recommendedBadgeIcon,
  leftBg,
  rightBg,
}) => {
  return (
    <TableWrapper>
      <StyledTable leftBg={leftBg} rightBg={rightBg}>
        <thead>
          <tr>
            <th className="col-left">
              {showRecommendedBadge && (
                <RecommendedBadge>
                  {recommendedBadgeIcon}
                  {recommendedBadgeText}
                </RecommendedBadge>
              )}
              <div>
                {leftIcon && <IconImg src={leftIcon} alt="" />}
                {leftTitle}
              </div>
            </th>
            <th className="col-right">
              <div>
                {rightIcon && <IconImg src={rightIcon} alt="" />}
                {rightTitle}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {leftRows.map((row, i) => (
            <tr key={i}>
              <td className="col-left">
                <CellInner>
                  {row.icon && <IconImg src={row.icon} alt="" />}
                  {row.text}
                </CellInner>
              </td>
              <td className="col-right">
                <CellInner>
                  {rightRows[i]?.icon && (
                    <IconImg src={rightRows[i].icon} alt="" />
                  )}
                  {rightRows[i]?.text}
                </CellInner>
              </td>
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </TableWrapper>
  );
};

export default ComparisonTable;
